import React, { useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogBody,
  DialogSurface,
  DialogTitle,
  Button,
  mergeClasses,
} from '@fluentui/react-components';
import { Dismiss20Regular } from '@fluentui/react-icons';

import { AdsStudioTargetFolderPicker } from './target-folder-picker-view';
import { useTargetFolderPickerStyle } from './target-folder-picker-style';

// const modalWidth = 940;

export const TargetFolderPickerModal = ({
  dataService, isGlobalSearch, sourceFolderId, show, onMoveHereClick, onCancel, i18n, ...rest
}) => {
  const [selectedFolder, setSelectedFolder] = useState(null);

  const { currentFolderId } = dataService;

  const onMoveClickButtonClick = () => {
    onMoveHereClick(currentFolderId);
  };

  const moveHereButtonDisabled = !isGlobalSearch && (currentFolderId === sourceFolderId);

  const DismissIcon = useMemo(() => <Dismiss20Regular onClick={onCancel} />, [onCancel]);

  const classes = useTargetFolderPickerStyle();

  return (
    <Dialog
      open={show}
      onDismiss={onCancel}
    >
      <DialogSurface className={mergeClasses('move-folder-dialog', classes.dialog)}>
        <DialogBody>
          <DialogTitle action={DismissIcon}>{i18n.getString(_TL_('Select folder'))}</DialogTitle>
          <DialogContent className="target-folder-picker-wrapper">
            <AdsStudioTargetFolderPicker
              dataService={dataService}
              selectedFolder={selectedFolder}
              setSelectedFolder={setSelectedFolder}
              i18n={i18n}
              {...rest}
            />
          </DialogContent>
          <DialogActions position="start">
            <Button className={mergeClasses(!moveHereButtonDisabled ? 'confirm-move' : '')} onClick={onMoveClickButtonClick} disabled={moveHereButtonDisabled} appearance="primary" >{i18n.getString(_TL_('Move here'))}</Button>
            <Button onClick={onCancel} >{i18n.getString(_TL_('Cancel'))}</Button>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
};

TargetFolderPickerModal.propTypes = {
  dataService: PropTypes.shape({
    currentFolderId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  }).isRequired,
  isGlobalSearch: PropTypes.bool.isRequired,
  sourceFolderId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  show: PropTypes.bool.isRequired,
  onMoveHereClick: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  notificationApi: PropTypes.shape({
    showWarning: PropTypes.func,
  }).isRequired,
};
